import { Link } from "react-router-dom";
import {
  ChevronDoubleLeftIcon,
  ChevronDoubleRightIcon,
  LogoutIcon,
} from "@heroicons/react/outline";
import { NAV_ITEMS } from "./navItems";

const DesktopSidebar = ({ pathname, collapsed, onToggleCollapsed, onSignOut }) => (
  <aside className={`ds-sidebar ${collapsed ? "is-collapsed" : ""}`}>
    <Link to="/" className="ds-brand" title="MySolon">
      <img src="/images/logo.jpeg" alt="" className="ds-brand-logo" />
      {!collapsed && <span className="ds-brand-name">MySolon</span>}
    </Link>

    <nav className="ds-nav" aria-label="Κύρια πλοήγηση">
      {NAV_ITEMS.map(({ to, label, icon: Icon, match }) => {
        const active = match(pathname);
        return (
          <Link
            key={to}
            to={to}
            className={`ds-nav-item ${active ? "is-active" : ""}`}
            aria-current={active ? "page" : undefined}
            title={collapsed ? label : undefined}
          >
            <Icon className="ds-nav-icon" aria-hidden="true" />
            {!collapsed && <span>{label}</span>}
          </Link>
        );
      })}
    </nav>

    <div className="ds-sidebar-footer">
      <a
        href="/"
        className="ds-nav-item"
        onClick={(e) => {
          e.preventDefault();
          onSignOut();
        }}
        title={collapsed ? "Αποσύνδεση" : undefined}
      >
        <LogoutIcon className="ds-nav-icon" aria-hidden="true" />
        {!collapsed && <span>Αποσύνδεση</span>}
      </a>
      <button
        type="button"
        className="ds-nav-item ds-collapse-btn"
        onClick={onToggleCollapsed}
        aria-label={collapsed ? "Ανάπτυξη μενού" : "Σύμπτυξη μενού"}
        title={collapsed ? "Ανάπτυξη μενού" : "Σύμπτυξη μενού"}
      >
        {collapsed ? (
          <ChevronDoubleRightIcon className="ds-nav-icon" aria-hidden="true" />
        ) : (
          <>
            <ChevronDoubleLeftIcon className="ds-nav-icon" aria-hidden="true" />
            <span>Σύμπτυξη</span>
          </>
        )}
      </button>
    </div>
  </aside>
);

export default DesktopSidebar;
